import * as historyActions from './historySlice'

export const setPreviousLocation = (payload = true) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(historyActions.setPreviousLocation(payload))
      resolve(payload)
    })
  }
}
